import $axios from '~/plugins/axios';

import { Api, GetSettingTagParams, PaginatorResult, Tag } from '~/api';
import { buildModule, createPaginationModule } from '../utils';
import { Dict, createDict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'tagsPage',
			pageSizeQueryKey: 'tagsPerPage',
			itemCountGetter: 'tags/list/totalCount',
		}),
	})
	.withState({
		storedTags: {} as Dict<Tag>,
		tags: [] as Tag[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byId: state => (tagId: Tag['id']): Tag | null => (
			state.storedTags[tagId] ?? null
		),
		page: state => state.tags,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_STORED_TAGS (state, tags: Tag[]) {
			state.storedTags = {
				...state.storedTags,
				...createDict(tags, (tag) => tag.id),
			};
		},
		SET_TAGS (state, tagIds: Tag['id'][]) {
			state.tags = tagIds.map(id => state.storedTags[id]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetSettingTagParams) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/setting/tag', { params });
			commit('SET_LOADING', false);

			const tags = data.payload;
			const tagIds = tags.map(tag => tag.id);

			commit('SET_STORED_TAGS', tags);
			commit('SET_TAGS', tagIds);
			commit('SET_PAGINATOR', data.paginator);
		},
	});
